import { Box, Grid } from "@mui/material";
import { toast } from "react-hot-toast";
import CustomInput from "../CustomInput";
import { useRef, useState, useEffect } from "react";
import PageForm from "../PageForm";
import { useIntl } from "react-intl";

export default function SummaryFilters({styleCodes, fabricCodes, sizes, checkedOutcomes, sendDataToParent, sendModelToParent, sendAspectToParent, sendSizeToParent, sendOutcomeToParent}) {
  const intl = useIntl();
  const [selectedChart, setSelectedChart] = useState("outcome");
  const [availableCharts, setAvailableCharts] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [availableModels, setAvailableModels] = useState([]);
  const [selectedAspect, setSelectedAspect] = useState("");
  const [availableAspects, setAvailableAspects] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [availableSizes, setAvailableSizes] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState("");
  const [availableOutcomes, setAvailableOutcomes] = useState([]);

  useEffect(() => {
    sendDataToParent(selectedChart)
    sendModelToParent(selectedModel)
    sendAspectToParent(selectedAspect)
    sendSizeToParent(selectedSize)
    //sendOutcomeToParent(selectedOutcome)
    sendOutcomeToParent(selectedOutcome == intl.formatMessage({ id: "QC.ToGo" }) ? 0 : selectedOutcome)
  }, [selectedChart, selectedModel, selectedAspect, selectedSize, selectedOutcome]);
  
  useEffect(() => {
    setAvailableCharts([
      { value: "outcome", text: intl.formatMessage({ id: "QC.Outcome" }) },
      { value: "model", text: intl.formatMessage({ id: "QC.Model" }) },
      { value: "aspect", text: intl.formatMessage({ id: "QC.Aspect" }) },
      { value: "size", text: intl.formatMessage({ id: "QC.Size" }) },
    ]);

    setAvailableModels(styleCodes)
    setAvailableAspects(fabricCodes)
    setAvailableSizes(sizes)
    setAvailableOutcomes(checkedOutcomes)
  }, [availableModels]);  

  useEffect(() => {
    if(selectedChart.length == 0){
      setSelectedChart("outcome")
    }
  }, [selectedChart]);  

  useEffect(() => {
    if(selectedOutcome == null){
      setSelectedOutcome(intl.formatMessage({ id: "QC.ToGo" }))
    }
  }, [selectedOutcome]);  

   return (
    <Box>
      <PageForm
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item xl={3} xs={12}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Chart" })}
                  type="select"
                  valueRef={selectedChart}
                  selectItems={availableCharts}
                  setValue={setSelectedChart}
                  inputCol={8}
                  textCol={4}
                />
              </Grid>
              <Grid item xl={3} xs={12}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Model" })}
                  type="select"
                  valueRef={selectedModel}
                  selectItems={availableModels}
                  setValue={setSelectedModel}
                  inputCol={8}
                  textCol={4}
                />
              </Grid>
              <Grid item xl={3} xs={12}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Aspect" })}
                  type="select"
                  valueRef={selectedAspect}
                  selectItems={availableAspects}
                  setValue={setSelectedAspect}
                  inputCol={8}
                  textCol={4}
                />
              </Grid>
              <Grid item xl={3} xs={12}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Size" })}
                  type="select"
                  valueRef={selectedSize}
                  selectItems={availableSizes}
                  setValue={setSelectedSize}
                  inputCol={8}
                  textCol={4}
                />
              </Grid>
              <Grid item xl={12} xs={12}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.Outcome" })}
                  type="select"
                  valueRef={selectedOutcome}
                  selectItems={availableOutcomes}
                  setValue={setSelectedOutcome}
                  inputCol={11}
                  textCol={1}
                />
              </Grid>
            </Grid>
          </form>
        }
      />
    </Box>
  );
}
